import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import icTick from 'assets/svg/ic_tick.svg';
import { TEST_ID_PROP_NAME } from '@wolffun/testable-id';

const Checkbox = ({
  className,
  check,
  onToggle,
  disabled,
  [TEST_ID_PROP_NAME]: dataTestId
}) => {
  return /*#__PURE__*/React.createElement("div", {
    [TEST_ID_PROP_NAME]: dataTestId,
    className: classNames(styles.box, check && styles.checked, disabled && styles.disabled, className),
    onClick: () => onToggle === null || onToggle === void 0 ? void 0 : onToggle(!check)
  }, /*#__PURE__*/React.createElement("img", {
    className: classNames(styles.check, !check && styles.hide, disabled && styles.disabled),
    src: icTick
  }));
};

export default Checkbox;